import { default as AccessTime, default as AccessTimeIcon } from "@mui/icons-material/AccessTime";
import AddIcon from "@mui/icons-material/Add";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import AdjustIcon from "@mui/icons-material/Adjust";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AlarmIcon from "@mui/icons-material/Alarm";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import ApiIcon from "@mui/icons-material/Api";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssistantIcon from "@mui/icons-material/Assistant";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BusinessIcon from "@mui/icons-material/Business";
import CableIcon from "@mui/icons-material/Cable";
import CachedIcon from "@mui/icons-material/Cached";
import CalculateIcon from "@mui/icons-material/Calculate";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import CancelIcon from "@mui/icons-material/Cancel";
import CarCrashIcon from "@mui/icons-material/CarCrash";
import CarRepairIcon from "@mui/icons-material/CarRepair";
import CategoryIcon from "@mui/icons-material/Category";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CodeIcon from "@mui/icons-material/Code";
import DirectionsCarsIcon from "@mui/icons-material/Commute";
import CompareIcon from "@mui/icons-material/Compare";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ConstructionIcon from "@mui/icons-material/Construction";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import EditOffIcon from "@mui/icons-material/EditOff";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import EmailIcon from "@mui/icons-material/Email";
import ErrorIcon from "@mui/icons-material/Error";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FlagIcon from "@mui/icons-material/Flag";
import FolderIcon from "@mui/icons-material/Folder";
import ForwardIcon from "@mui/icons-material/Forward";
import GridOffIcon from "@mui/icons-material/GridOff";
import GroupsIcon from "@mui/icons-material/Groups";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HeartBrokenIcon from "@mui/icons-material/HeartBroken";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HistoryIcon from "@mui/icons-material/History";
import HomeIcon from "@mui/icons-material/Home";
import ImageIcon from "@mui/icons-material/Image";
import InfoIcon from "@mui/icons-material/Info";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import LanguageIcon from "@mui/icons-material/Language";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import LinkIcon from "@mui/icons-material/Link";
import ListIcon from "@mui/icons-material/List";
import LocalCarWash from "@mui/icons-material/LocalCarWash";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import MergeIcon from "@mui/icons-material/Merge";
import MessageIcon from "@mui/icons-material/Message";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import NotesIcon from "@mui/icons-material/Notes";
import NumbersIcon from "@mui/icons-material/Numbers";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { default as PageViewIcon, default as PageviewIcon } from "@mui/icons-material/Pageview";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PaymentIcon from "@mui/icons-material/Payment";
import PaymentsIcon from "@mui/icons-material/Payments";
import PendingIcon from "@mui/icons-material/Pending";
import PeopleIcon from "@mui/icons-material/People";
import PercentIcon from "@mui/icons-material/Percent";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import PhoneIcon from "@mui/icons-material/Phone";
import PlaceIcon from "@mui/icons-material/Place";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PreviewIcon from "@mui/icons-material/Preview";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import PublicIcon from "@mui/icons-material/Public";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import PushPinIcon from "@mui/icons-material/PushPin";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RefreshIcon from "@mui/icons-material/Refresh";
import RemoveIcon from "@mui/icons-material/Remove";
import ReplayIcon from "@mui/icons-material/Replay";
import ReplyIcon from "@mui/icons-material/Reply";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RestoreIcon from "@mui/icons-material/Restore";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import SellIcon from "@mui/icons-material/Sell";
import SendIcon from "@mui/icons-material/Send";
import AccountTreeIcon from "@mui/icons-material/Share";
import ShieldIcon from "@mui/icons-material/Shield";
import Shower from "@mui/icons-material/Shower";
import SourceIcon from "@mui/icons-material/Source";
import StopIcon from "@mui/icons-material/Stop";
import StorageIcon from "@mui/icons-material/Storage";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import TableRowsIcon from "@mui/icons-material/TableRows";
import TerminalOutlinedIcon from "@mui/icons-material/TerminalOutlined";
import TextureIcon from "@mui/icons-material/Texture";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import TodayIcon from "@mui/icons-material/Today";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WebIcon from "@mui/icons-material/Web";
import WidgetsIcon from "@mui/icons-material/Widgets";
import SuitCaseIcon from "@mui/icons-material/Work";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactNode, forwardRef } from "react";

import FileIcon from "../Files/FileIcon";
import AppTooltip from "../Tooltip/AppTooltip";
import ExpandCircleUp from "./FromMui/ExpandCircleUp";
import AccessoriesIcon from "./Svg/AccessoriesIcon";
import AccessoryChecksIcon from "./Svg/AccessoryChecksIcon";
import ActiveOperationsIcon from "./Svg/ActiveOperationsIcon";
import ArrowDownLeftIcon from "./Svg/ArrowDownLeftIcon";
import ArrowUpRightIcon from "./Svg/ArrowUpRightIcon";
import AssetSubscriptionIcon from "./Svg/AssetSubscriptionIcon";
import AssetSubscriptionPlanIcon from "./Svg/AssetSubscriptionPlanIcon";
import AssetsIcon from "./Svg/AssetsIcon";
import BulbIcon from "./Svg/BulbIcon";
import CalendarIcon from "./Svg/CalendarIcon";
import CancelCircleIcon from "./Svg/CancelCircleIcon";
import CancelCircleOutlineIcon from "./Svg/CancelCircleOutlineIcon";
import ChatIcon from "./Svg/ChatIcon";
import CheckCircleIcon from "./Svg/CheckCircleIcon";
import CheckCircleOutlineIcon from "./Svg/CheckCircleOutlineIcon";
import CheckIcon from "./Svg/CheckIcon";
import ClockIcon from "./Svg/ClockIcon";
import ClockOutlineIcon from "./Svg/ClockOutlineIcon";
import CloudUploadIcon from "./Svg/CloudUploadIcon";
import CoinStackCheckIcon from "./Svg/CoinStackCheckIcon";
import CoinStackIcon from "./Svg/CoinStackIcon";
import CollapseIcon from "./Svg/CollapseIcon";
import ColumnsIcon from "./Svg/ColumnsIcon";
import ConnectionsIcon from "./Svg/ConnectionsIcon";
import ContractsIcon from "./Svg/ContractsIcon";
import CustomTagsIcon from "./Svg/CustomTagsIcon";
import CustomersIcon from "./Svg/CustomersIcon";
import DamageCostEvaluationsIcon from "./Svg/DamageCostEvaluationsIcon";
import DamageDetectionsIcon from "./Svg/DamageDetectionsIcon";
import DamageWithShieldIcon from "./Svg/DamageWithShieldIcon";
import DamagesAndApprovalsIcon from "./Svg/DamagesAndApprovalsIcon";
import DashboardIcon from "./Svg/DashboardIcon";
import DataConnectedIcon from "./Svg/DataConnectedIcon";
import DataGrantsIcon from "./Svg/DataGrantsIcon";
import DataIcon from "./Svg/DataIcon";
import DeleteIcon from "./Svg/DeleteIcon";
import DepartmentIcon from "./Svg/DepartmentIcon";
import DocIcon from "./Svg/DocIcon";
import DownloadIcon from "./Svg/DownloadIcon";
import EditIcon from "./Svg/EditIcon";
import ExpandIcon from "./Svg/ExpandIcon";
import ExpandLessIcon from "./Svg/ExpandLessIcon";
import ExpandMoreIcon from "./Svg/ExpandMoreIcon";
import FilterIcon from "./Svg/FilterIcon";
import FuelIcon from "./Svg/FuelIcon";
import GaugeIcon from "./Svg/GaugeIcon";
import GaugeTimeIcon from "./Svg/GaugeTimeIcon";
import HelpIcon from "./Svg/HelpIcon";
import InfoOutlineIcon from "./Svg/InfoOutlineIcon";
import LocationIcon from "./Svg/LocationIcon";
import AppLogoFullIcon from "./Svg/Logo/AppLogoFullIcon";
import AppLogoIcon from "./Svg/Logo/AppLogoIcon";
import ManagementIcon from "./Svg/ManagementIcon";
import MaterialsIcon from "./Svg/MaterialsIcon";
import ModificationIcon from "./Svg/ModificationIcon";
import NegotiationsIcon from "./Svg/NegotiationsIcon";
import NotificationsIcon from "./Svg/NotificationsIcon";
import OperationsIcon from "./Svg/OperationsIcon";
import PersonIdIcon from "./Svg/PersonIdIcon";
import PersonOutlineIcon from "./Svg/PersonOutlineIcon";
import PinIcon from "./Svg/PinIcon";
import PlateNoIcon from "./Svg/PlateNoIcon";
import PoolIcon from "./Svg/Pool";
import ProductsIcon from "./Svg/ProductsIcon";
import RepairCar from "./Svg/RepairCar";
import RepairIcon from "./Svg/RepairIcon";
import RepairsIcon from "./Svg/RepairsIcon";
import RequestsIcon from "./Svg/RequestsIcon";
import SalesLocationsIcon from "./Svg/SalesLocationsIcon";
import SearchIcon from "./Svg/SearchIcon";
import SettingsIcon from "./Svg/SettingsIcon";
import ShieldCancelCircleIcon from "./Svg/ShieldCancelCircleIcon";
import ShieldCheckCircleIcon from "./Svg/ShieldCheckCircleIcon";
import SmashIcon from "./Svg/SmashIcon";
import SmashTimeIcon from "./Svg/SmashTimeIcon";
import SortIcon from "./Svg/SortIcon";
import SparePartsIcon from "./Svg/SparePartsIcon";
import SparklesIcon from "./Svg/SparklesIcon";
import SpecsIcon from "./Svg/SpecsIcon";
import SunIcon from "./Svg/SunIcon";
import SuppliersIcon from "./Svg/SuppliersIcon";
import SwitchTenantIcon from "./Svg/SwitchTenantIcon";
import VehicleFrontIcon from "./Svg/VehicleFrontIcon";
import VehicleSideIcon from "./Svg/VehicleSideIcon";
import VisualInspectionsIcon from "./Svg/VisualInspectionsIcon";
import WarningTriangleIcon from "./Svg/WarningTriangleIcon";
import WorkIcon from "./Svg/WorkIcon";

export const AppIconOf = {
  // general

  none: true,
  create: true,
  add: true,
  edit: true,
  editOff: true,
  editInline: true,
  settings: true,
  delete: true,
  remove: true,
  removePerson: true,
  clear: true,
  undelete: true,
  restore: true,
  restart: true,
  reset: true,
  copy: true,
  clone: true,
  duplicate: true,
  circle: true,
  circleOutline: true,
  check: true,
  checkCircle: true,
  checkCircleOutline: true,
  cross: true,
  email: true,
  mail: true,
  phone: true,
  operations: true,
  activeOperations: true,
  view: true,
  quickView: true,
  preview: true,
  details: true,
  hide: true,
  item: true,
  download: true,
  openInNew: true,
  openInFull: true,
  agree: true,
  disagree: true,
  done: true,
  clock: true,
  waiting: true,
  pending: true,
  info: true,
  help: true,
  tip: true,
  apply: true,
  reapply: true,
  accept: true,
  approve: true,
  approveAll: true,
  approved: true,
  decline: true,
  declineAll: true,
  declined: true,
  forceApprove: true,
  forceApproved: true,
  forceDecline: true,
  forceDeclined: true,
  acknowledge: true,
  pin: true,
  unpin: true,
  close: true,
  list: true,
  selectFromList: true,
  message: true,
  moreVert: true,
  moreHoriz: true,
  expandMore: true,
  expandMoreOutline: true,
  expandLess: true,
  expandLessOutline: true,
  chevronLeft: true,
  chevronRight: true,
  keyboardArrowLeft: true,
  keyboardDoubleArrowLeft: true,
  keyboardArrowRight: true,
  keyboardDoubleArrowRight: true,
  leave: true,
  exit: true,
  logout: true,
  history: true,
  data: true,
  dataConnected: true,
  entity: true,
  noData: true,
  notFound: true,
  contact: true,
  contacted: true,
  dev: true,
  code: true,
  goBack: true,
  person: true,
  profile: true,
  arrowDropDown: true,
  arrowDropUp: true,
  money: true,
  price: true,
  cost: true,
  costCheck: true,
  coinStack: true,
  coinStackCheck: true,
  percent: true,
  upload: true,
  import: true,
  export: true,
  notes: true,
  addNotes: true,
  attachment: true,
  attachments: true,
  addAttachments: true,
  invite: true,
  invites: true,
  expired: true,
  send: true,
  resend: true,
  return: true,
  isFree: true,
  isPaid: true,
  enabled: true,
  disabled: true,
  start: true,
  dashboard: true,
  exclamationMark: true,
  visibility: true,
  visibilityOff: true,
  other: true,
  tag: true,
  customTag: true,
  subItem: true,
  webApp: true,
  success: true,
  successFilled: true,
  warning: true,
  error: true,
  address: true,
  reminder: true,
  reminderOn: true,
  reminderOff: true,
  suspend: true,
  unsuspend: true,
  arrowBack: true,
  arrowForward: true,
  arrowUpward: true,
  arrowDownward: true,
  replay: true,
  image: true,
  photo: true,
  file: true,
  files: true,
  session: true,
  modification: true,
  mileage: true,
  gauge: true,
  gaugeTime: true,
  damage: true,
  damageTime: true,
  damageShield: true,
  refresh: true,
  recompute: true,
  search: true,
  globalSearch: true,
  country: true,
  currency: true,
  culture: true,
  duration: true,
  availability: true,
  unpaid: true,
  active: true,
  activate: true,
  pastDue: true,
  ended: true,
  paused: true,
  cancel: true,
  cancelOutline: true,
  canceled: true,
  revoke: true,
  nothing: true,
  respond: true,
  complete: true,
  report: true,
  menu: true,
  folder: true,
  pageView: true,
  bookmarkBorder: true,
  bookmark: true,
  favorite: true,
  link: true,
  addRoad: true,
  widgets: true,
  notifications: true,
  date: true,
  time: true,
  swapHoriz: true,
  swapVert: true,
  draft: true,
  center: true,
  zoomIn: true,
  zoomOut: true,
  rotateLeft: true,
  rotateRight: true,
  global: true,
  moveFile: true,
  moveFolder: true,
  moveItem: true,
  columns: true,
  rows: true,
  sort: true,
  sorting: true,
  sortAsc: true,
  sortDesc: true,
  filter: true,
  filters: true,
  bulb: true,
  sun: true,
  status: true,
  calculate: true,
  calculation: true,
  local: true,
  internal: true,
  external: true,
  split: true,
  merge: true,
  source: true,
  origin: true,
  number: true,
  count: true,
  compare: true,
  expand: true,
  collapse: true,

  // specific
  appLogo: true,
  appLogoFull: true,
  role: true,
  roles: true,
  permission: true,
  permissions: true,
  user: true,
  users: true,
  inspector: true,
  accessory: true,
  accessoryInOrder: true,
  accessoryMissing: true,
  accessoryDamaged: true,
  vehicle: true,
  vehicleSide: true,
  vehicles: true,
  contract: true,
  contracts: true,
  customer: true,
  customers: true,
  supplier: true,
  suppliers: true,
  invoice: true,
  invoices: true,
  visualInspection: true,
  visualInspections: true,
  damageDetections: true,
  damageDetection: true,
  damageDetectionAggregate: true,
  damageCostEvaluation: true,
  damageCostEvaluationAggregate: true,
  damageCostEvaluations: true,
  wash: true,
  washType: true,
  washScheduleType: true,
  maintenance: true,
  maintenanceScheduleType: true,
  department: true,
  departments: true,
  location: true,
  productLocation: true,
  spot: true,
  accessoryCheck: true,
  accessoryChecks: true,
  repairCar: true,
  repairOperation: true,
  repairOperations: true,
  documents: true,
  document: true,
  calendar: true,
  inbox: true,
  chat: true,
  chatMessage: true,
  chatEvent: true,
  chatPersonal: true,
  chatGroup: true,
  chatComment: true,
  chatNegotiation: true,
  negotiation: true,
  negotiations: true,
  negotiationProposal: true,
  repair: true,
  repairMaterial: true,
  repairWork: true,
  repairSparePart: true,
  repairSpec: true,
  vehicleDamage: true,
  flow: true,
  flows: true,
  fuel: true,
  assessmentFlow: true,
  management: true,
  integration: true,
  apiClient: true,
  integrationApiClient: true,
  subscription: true,
  subscriptionPlan: true,
  assetSubscriptionPlan: true,
  assetSubscription: true,
  adminPanel: true,
  payment: true,
  paymentProfile: true,
  party: true,
  consensus: true,
  forcedConsensus: true,
  noConsensus: true,
  company: true,
  companyProfile: true,
  switchTenant: true,
  createNewTenant: true,
  tenant: true,
  tenants: true,
  tenantProfile: true,
  tenantToTenant: true,
  tenantConnection: true,
  tenantRequest: true,
  tenantRequestAppliedResult: true,
  crossTenantBrowse: true,
  dataGrant: true,
  referenceData: true,
  switchAccount: true,
  vehiclePartType: true,
  vehicleVisualModel: true,
  vehicleMake: true,
  vehicleModel: true,
  vehicleGeneration: true,
  vehicleModification: true,
  damageType: true,
  plateNo: true,
  VIN: true,
  personId: true,
  personOutline: true,
  product: true,
  pool: true,
  poolItem: true,
  pinLocation: true,
  asset: true,
  includedOption: true,
  extraOption: true,
  theme: true,
  checkOut: true,
  checkIn: true,
  tesla: true,
  teslaConnection: true,
  wheelOperation: true,
  assignment: true,
  assistant: true,
  sparkles: true,
  charge: true,
  localNumber: true,
  globalNumber: true,
  externalNumber: true,
} as const;
export type AppIconOf = keyof typeof AppIconOf;

export type AppIconProps = SvgIconProps & {
  /** What entity/object this icon represents. */
  of: AppIconOf;
  /** Whether icon is rendered in text and should be vertically aligned. */
  inText?: boolean;
  tooltipTitle?: string | ReactNode;
};

type IconType = typeof SvgIcon | ReturnType<typeof forwardRef>;

const iconMap: Record<AppIconProps["of"], IconType> = {
  // general
  none: RemoveIcon,
  create: AddIcon,
  add: AddIcon,
  edit: EditIcon as IconType,
  editOff: EditOffIcon,
  editInline: DriveFileRenameOutlineIcon,
  settings: SettingsIcon as IconType,
  remove: DeleteIcon as IconType,
  removePerson: PersonRemoveIcon,
  delete: DeleteIcon as IconType,
  clear: ClearIcon,
  undelete: RestoreIcon,
  restore: RestoreIcon,
  restart: RestartAltIcon,
  reset: RestartAltIcon,
  copy: ContentCopyIcon,
  clone: ContentCopyIcon,
  duplicate: ContentCopyIcon,
  circle: CircleIcon,
  circleOutline: CircleOutlinedIcon,
  check: CheckIcon as IconType,
  checkCircle: CheckCircleIcon as IconType,
  checkCircleOutline: CheckCircleOutlineIcon as IconType,
  cross: ClearIcon,
  email: EmailIcon,
  mail: EmailIcon,
  phone: PhoneIcon,
  operations: OperationsIcon as IconType,
  activeOperations: ActiveOperationsIcon as IconType,
  view: VisibilityIcon,
  quickView: PageviewIcon,
  preview: PreviewIcon,
  details: InfoIcon,
  hide: VisibilityOffIcon,
  item: DataIcon as IconType,
  download: FileDownloadOutlinedIcon,
  openInNew: OpenInNewIcon,
  openInFull: OpenInFullIcon,
  agree: ThumbUpIcon,
  disagree: ThumbDownIcon,
  done: CheckIcon as IconType,
  clock: ClockIcon as IconType,
  waiting: ClockOutlineIcon as IconType,
  pending: PendingIcon,
  info: InfoOutlineIcon as IconType,
  help: HelpIcon as IconType,
  tip: LightbulbIcon,
  apply: CheckCircleIcon as IconType,
  reapply: PublishedWithChangesIcon,
  accept: CheckCircleIcon as IconType,
  approve: CheckCircleIcon as IconType,
  approveAll: CheckCircleOutlineIcon as IconType,
  approved: CheckCircleIcon as IconType,
  decline: CancelCircleIcon as IconType,
  declineAll: CancelCircleOutlineIcon as IconType,
  declined: CancelCircleIcon as IconType,
  forceApprove: ShieldCheckCircleIcon as IconType,
  forceApproved: ShieldCheckCircleIcon as IconType,
  forceDecline: ShieldCancelCircleIcon as IconType,
  forceDeclined: ShieldCancelCircleIcon as IconType,
  acknowledge: DoneAllIcon,
  pin: PushPinIcon,
  unpin: PushPinIcon,
  close: CloseIcon,
  list: ListIcon,
  selectFromList: ListIcon,
  message: MessageIcon,
  moreVert: MoreVertIcon,
  moreHoriz: MoreHorizIcon,
  expandMore: ExpandMoreIcon as IconType,
  expandMoreOutline: ExpandCircleDownIcon,
  expandLess: ExpandLessIcon as IconType,
  expandLessOutline: ExpandCircleUp as IconType,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  keyboardArrowLeft: KeyboardArrowLeftIcon,
  keyboardDoubleArrowLeft: KeyboardDoubleArrowLeftIcon,
  keyboardArrowRight: KeyboardArrowRightIcon,
  keyboardDoubleArrowRight: KeyboardDoubleArrowRightIcon,
  leave: LogoutIcon,
  exit: LogoutIcon,
  logout: LogoutIcon,
  history: HistoryIcon,
  data: DataIcon as IconType,
  dataConnected: DataConnectedIcon as IconType,
  entity: DataIcon as IconType,
  noData: GridOffIcon,
  notFound: SearchOffIcon,
  contact: PersonIcon,
  contacted: ConnectWithoutContactIcon,
  dev: TerminalOutlinedIcon,
  code: CodeIcon,
  goBack: ArrowBackIcon,
  person: PersonIcon,
  profile: PersonIcon,
  arrowDropDown: ArrowDropDownIcon,
  arrowDropUp: ArrowDropUpIcon,
  money: PaymentsIcon,
  price: PaymentsIcon,
  cost: CoinStackIcon as IconType,
  costCheck: CoinStackCheckIcon as IconType,
  coinStack: CoinStackIcon as IconType,
  coinStackCheck: CoinStackCheckIcon as IconType,
  percent: PercentIcon,
  upload: CloudUploadIcon as IconType,
  import: CloudUploadIcon as IconType,
  export: DownloadIcon as IconType,
  notes: NotesIcon,
  addNotes: PostAddIcon,
  attachment: AttachFileIcon,
  attachments: AttachFileIcon,
  addAttachments: AttachFileIcon,
  invite: EmailIcon,
  invites: PersonAddIcon,
  expired: TimerOffIcon,
  // send: PaperPlaneIcon as iconType, // 45 degrees paper plane that looks misaligned in a square icon box
  send: SendIcon, // 45 degrees paper plane that looks misaligned in a square icon box
  resend: SendIcon,
  return: KeyboardReturnIcon,
  isFree: MoneyOffIcon,
  isPaid: AttachMoneyIcon,
  enabled: CheckIcon as IconType,
  disabled: UnpublishedIcon,
  start: PlayCircleOutlineIcon,
  dashboard: DashboardIcon as IconType,
  exclamationMark: PriorityHighIcon,
  visibility: VisibilityIcon,
  visibilityOff: VisibilityOffIcon,
  other: MoreHorizIcon,
  tag: SellIcon,
  customTag: CustomTagsIcon as IconType,
  subItem: AccountTreeIcon,
  webApp: WebIcon,
  success: CheckIcon as IconType,
  successFilled: CheckCircleIcon as IconType,
  warning: WarningTriangleIcon as IconType,
  error: ErrorIcon,
  address: HomeIcon,
  reminder: AlarmIcon,
  reminderOn: AlarmIcon,
  reminderOff: AlarmOffIcon,
  suspend: PersonOffIcon,
  unsuspend: PersonAddIcon,
  arrowBack: ArrowBackIcon,
  arrowForward: ArrowForwardIcon,
  arrowUpward: ArrowUpwardIcon,
  arrowDownward: ArrowDownwardIcon,
  replay: ReplayIcon,
  image: ImageIcon,
  photo: ImageIcon,
  file: FileIcon as IconType,
  files: FileIcon as IconType,
  session: PermIdentityIcon,
  personId: PersonIdIcon as IconType,
  personOutline: PersonOutlineIcon as IconType,
  modification: ModificationIcon as IconType,
  mileage: GaugeIcon as IconType,
  gauge: GaugeIcon as IconType,
  gaugeTime: GaugeTimeIcon as IconType,
  damage: SmashIcon as IconType,
  damageTime: SmashTimeIcon as IconType,
  damageShield: DamageWithShieldIcon as IconType,
  refresh: RefreshIcon,
  recompute: CachedIcon,
  search: SearchIcon as IconType,
  globalSearch: TravelExploreIcon,
  country: FlagIcon,
  currency: AttachMoneyIcon,
  culture: LanguageIcon,
  duration: TimelapseIcon,
  availability: ChecklistIcon,
  unpaid: MoneyOffIcon,
  active: CheckCircleIcon as IconType,
  activate: CheckCircleIcon as IconType,
  pastDue: MoneyOffIcon,
  ended: StopIcon,
  paused: PauseCircleOutlineIcon,
  cancel: CancelIcon,
  cancelOutline: CancelCircleOutlineIcon as IconType,
  canceled: CancelIcon,
  revoke: CancelIcon,
  nothing: NotInterestedIcon,
  respond: ReplyIcon,
  complete: CheckCircleOutlineIcon as IconType,
  report: AssignmentTurnedInIcon,
  menu: MenuIcon,
  folder: FolderIcon,
  pageView: PageViewIcon,
  bookmarkBorder: BookmarkBorderIcon,
  bookmark: BookmarkIcon,
  favorite: FavoriteIcon,
  link: LinkIcon,
  addRoad: AddRoadIcon,
  widgets: WidgetsIcon,
  notifications: NotificationsIcon as IconType,
  date: TodayIcon,
  time: AccessTimeIcon,
  swapHoriz: SwapHorizIcon,
  swapVert: SortIcon as IconType,
  draft: EditNoteIcon,
  center: AdjustIcon,
  zoomIn: ZoomInIcon,
  zoomOut: ZoomOutIcon,
  rotateLeft: RotateLeftIcon,
  rotateRight: RotateRightIcon,
  global: PublicIcon,
  moveFile: ForwardIcon,
  moveFolder: DriveFileMoveIcon,
  moveItem: ForwardIcon,
  columns: ColumnsIcon as IconType,
  rows: TableRowsIcon,
  sorting: SortIcon as IconType,
  sort: SortIcon as IconType,
  sortAsc: ArrowUpwardIcon,
  sortDesc: ArrowDownwardIcon,
  filter: FilterIcon as IconType,
  filters: FilterIcon as IconType,
  bulb: BulbIcon as IconType,
  sun: SunIcon as IconType,
  status: BulbIcon as IconType,
  calculate: CalculateIcon,
  calculation: CalculateIcon,
  local: CallReceivedIcon,
  internal: CallReceivedIcon,
  external: CallMadeIcon,
  split: CallSplitIcon,
  merge: MergeIcon,
  source: SourceIcon,
  origin: SourceIcon,
  number: NumbersIcon,
  count: NumbersIcon,
  compare: CompareIcon,
  expand: ExpandIcon as IconType,
  collapse: CollapseIcon as IconType,

  // specific
  appLogo: AppLogoIcon as IconType,
  appLogoFull: AppLogoFullIcon as IconType,
  role: PermContactCalendarIcon,
  roles: PermContactCalendarIcon,
  permission: ShieldIcon,
  permissions: ShieldIcon,
  user: PersonIcon,
  users: PeopleIcon,
  inspector: PersonIcon,
  accessory: AccessoriesIcon as IconType,
  accessoryInOrder: CheckCircleOutlineIcon as IconType,
  accessoryMissing: HighlightOffIcon,
  accessoryDamaged: HeartBrokenIcon,
  vehicle: VehicleFrontIcon as IconType,
  vehicleSide: VehicleSideIcon as IconType,
  vehicles: DirectionsCarsIcon,
  contract: SuitCaseIcon,
  contracts: ContractsIcon as IconType,
  customer: PersonIcon,
  customers: CustomersIcon as IconType,
  supplier: SuppliersIcon as IconType,
  suppliers: SuppliersIcon as IconType,
  invoice: ReceiptIcon,
  invoices: ReceiptIcon,
  visualInspection: VisualInspectionsIcon as IconType,
  visualInspections: VisualInspectionsIcon as IconType,
  damageDetections: DamageDetectionsIcon as IconType,
  damageDetection: DamageDetectionsIcon as IconType,
  damageDetectionAggregate: DamageDetectionsIcon as IconType,
  damageCostEvaluation: DamageCostEvaluationsIcon as IconType,
  damageCostEvaluationAggregate: DamageCostEvaluationsIcon as IconType,
  damageCostEvaluations: DamageCostEvaluationsIcon as IconType,
  wash: LocalCarWash,
  washType: Shower,
  washScheduleType: AccessTime,
  maintenance: CarRepairIcon,
  maintenanceScheduleType: AccessTime,
  department: DepartmentIcon as IconType,
  departments: DepartmentIcon as IconType,
  location: LocationIcon as IconType,
  productLocation: SalesLocationsIcon as IconType,
  spot: PlaceIcon,
  accessoryCheck: AccessoryChecksIcon as IconType,
  accessoryChecks: AccessoryChecksIcon as IconType,
  repairCar: RepairCar as IconType,
  repairOperation: RepairsIcon as IconType,
  repairOperations: RepairsIcon as IconType,
  documents: DescriptionOutlined,
  document: DocIcon as IconType,
  calendar: CalendarIcon as IconType,
  inbox: ChatIcon as IconType,
  chat: ChatIcon as IconType,
  chatMessage: MessageIcon,
  chatEvent: ElectricBoltIcon,
  chatPersonal: ChatIcon as IconType,
  chatGroup: ChatIcon as IconType,
  chatComment: ChatIcon as IconType,
  chatNegotiation: ChatIcon as IconType,
  negotiation: NegotiationsIcon as IconType,
  negotiations: NegotiationsIcon as IconType,
  negotiationProposal: TipsAndUpdatesIcon,
  repair: RepairIcon as IconType,
  repairMaterial: MaterialsIcon as IconType,
  repairWork: WorkIcon as IconType,
  repairSparePart: SparePartsIcon as IconType,
  repairSpec: SpecsIcon as IconType,
  vehicleDamage: HeartBrokenIcon,
  flow: AccountTreeIcon,
  flows: AccountTreeIcon,
  fuel: FuelIcon as IconType,
  assessmentFlow: DamagesAndApprovalsIcon as IconType,
  management: ManagementIcon as IconType,
  integration: CableIcon,
  apiClient: ApiIcon,
  integrationApiClient: ApiIcon,
  payment: PaymentIcon,
  paymentProfile: PaymentIcon,
  pinLocation: PinIcon as IconType,
  subscription: SubscriptionsIcon,
  subscriptionPlan: SubscriptionsIcon,
  assetSubscriptionPlan: AssetSubscriptionPlanIcon as IconType,
  assetSubscription: AssetSubscriptionIcon as IconType,
  adminPanel: AdminPanelSettingsIcon,
  party: GroupsIcon,
  consensus: CheckIcon as IconType,
  forcedConsensus: ShieldCheckCircleIcon as IconType,
  noConsensus: CancelCircleIcon as IconType,
  company: BusinessIcon,
  companyProfile: BusinessIcon,
  switchTenant: SwitchTenantIcon as IconType,
  createNewTenant: CreateNewFolderOutlinedIcon,
  tenant: BusinessIcon,
  tenants: BusinessIcon,
  tenantProfile: BusinessIcon,
  tenantToTenant: HandshakeIcon,
  tenantConnection: ConnectionsIcon as IconType,
  tenantRequest: RequestsIcon as IconType,
  tenantRequestAppliedResult: PlaylistAddCheckCircleIcon,
  crossTenantBrowse: TravelExploreIcon,
  dataGrant: DataGrantsIcon as IconType,
  referenceData: StorageIcon,
  switchAccount: SwitchAccountIcon,
  vehiclePartType: ConstructionIcon,
  vehicleVisualModel: TextureIcon,
  vehicleMake: CategoryIcon,
  vehicleModel: CategoryIcon,
  vehicleGeneration: CategoryIcon,
  vehicleModification: CategoryIcon,
  damageType: CarCrashIcon,
  plateNo: PlateNoIcon as IconType,
  VIN: PersonIdIcon as IconType,
  product: ProductsIcon as IconType,
  pool: PoolIcon as IconType,
  poolItem: DataIcon as IconType,
  asset: AssetsIcon as IconType,
  includedOption: PlaylistAddCheckIcon,
  extraOption: PlaylistAddIcon,
  theme: LightModeOutlinedIcon,
  checkOut: ArrowDownLeftIcon as IconType,
  checkIn: ArrowUpRightIcon as IconType,
  tesla: VehicleFrontIcon as IconType,
  teslaConnection: VehicleFrontIcon as IconType,
  wheelOperation: CarRepairIcon as IconType,
  assignment: AssignmentIcon,
  assistant: AssistantIcon,
  sparkles: SparklesIcon as IconType,
  charge: PaymentIcon,
  localNumber: PersonIdIcon as IconType,
  globalNumber: PersonIdIcon as IconType,
  externalNumber: DataIcon as IconType,
};

/** Simplifies and unifies usage of MUI icons across the app.
 *  Also reduces number of imports in components using many icons.
 */
export default forwardRef<SVGSVGElement, AppIconProps>(function AppIcon(
  { of, inText, tooltipTitle, ...other }: AppIconProps,
  ref,
) {
  const IconComp = iconMap[of];
  if (!IconComp) {
    return null;
  }
  return (
    <AppTooltip isEnabled={!!tooltipTitle} title={tooltipTitle || ""}>
      <IconComp
        ref={ref}
        color='inherit'
        fontSize='inherit'
        {...other}
        sx={{
          verticalAlign: inText ? "middle" : undefined,
          ...(other?.sx || {}),
        }}
      />
    </AppTooltip>
  );
});
